import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M50 0C22.7-.3.3 21.5 0 48.8c-.3 20.8 12.6 39.6 32.1 46.9 1.6.6 3.4-.2 4-1.8 0 0 0-.1.1-.1L45.5 64c.4-1.4-.2-2.9-1.5-3.6-6-3.3-8.3-10.9-5-16.9 3.3-6.1 10.8-8.3 16.9-5.1 6.1 3.3 8.3 10.8 5.1 16.9-1.2 2.2-2.9 3.9-5.1 5.1-1.3.7-1.9 2.2-1.5 3.6l9.4 29.6c.5 1.6 2.3 2.6 3.9 2 0 0 .1 0 .1-.1 25.5-9.6 38.5-38 28.9-63.6C89.6 12.6 70.8-.3 50 0z" />
  </svg>
);
